import {
	CHANGE_ARTICLES_LIST_SETTINGS, PAGE_SHIFT_ARTICLES, RECEIVE_ARTICLE_ATTACHMENT, RECEIVE_ARTICLES_MESSAGE,
	RECEIVE_BAD_REQUEST_ARTICLES_MESSAGE,
	RECEIVE_DELETE_ARTICLE,
	RECEIVE_FAILED_RESPONSE_DELETE_ARTICLE,
	RECEIVE_FAILED_RESPONSE_GET_ARTICLES, RECEIVE_FAILED_RESPONSE_GET_ARTICLES_SOLICITOR_HOME_PAGE,
	RECEIVE_FAILED_RESPONSE_GET_SPECIFIC_ARTICLE,
	RECEIVE_FAILED_RESPONSE_PATCH_ARTICLE, RECEIVE_FAILURE_ARTICLE_ATTACHMENT, RECEIVE_GET_ARTICLES,
	RECEIVE_GET_ARTICLES_SOLICITOR_HOME_PAGE,
	RECEIVE_PATCH_ARTICLE, RECEIVE_SPECIFIC_ARTICLE, REQUEST_ARTICLE_ATTACHMENT, REQUEST_ARTICLES_MESSAGE,
	REQUEST_DELETE_ARTICLE,
	REQUEST_GET_ARTICLES, REQUEST_GET_ARTICLES_SOLICITOR_HOME_PAGE, REQUEST_GET_SELECTED_ARTICLE, REQUEST_PATCH_ARTICLE
} from "./index";

//action that changes the store settings
export function changeArticlesListSettings(key, value){
	return {
		type: CHANGE_ARTICLES_LIST_SETTINGS,
		payload: {
			key,
			value
		}
	}
}

//action that shifts the page value +-1
export function pageShiftArticles(direction, totalPaginationBoxes){
	return {
		type: PAGE_SHIFT_ARTICLES,
		payload: {
			direction: direction,
			totalPaginationBoxes: totalPaginationBoxes
		}
	}
}

//action that requests get article news
export function requestGetArticles(payload) {
	return {
		type: REQUEST_GET_ARTICLES,
		payload
	}
}

//action that receives all articles
export function receiveGetArticles(articles) {
	return {
		type: RECEIVE_GET_ARTICLES,
		payload: articles
	}
}

//action that  receives failed response from getting all articles
export function receivefailedResponseGetArticles(articles) {
	return {
		type: RECEIVE_FAILED_RESPONSE_GET_ARTICLES,
		payload: articles
	}
}


//action that requests get article news
export function requestGetArticlesSolicitorHomePage(payload) {
	return {
		type: REQUEST_GET_ARTICLES_SOLICITOR_HOME_PAGE,
		payload
	}
}

//action that receives all articles
export function receiveGetArticlesSolicitorHomePage(payload) {
	return {
		type: RECEIVE_GET_ARTICLES_SOLICITOR_HOME_PAGE,
		payload
	}
}

//action that  receives failed response from getting all articles
export function receiveFailureArticlesSolicitorHomePage(payload) {
	return {
		type: RECEIVE_FAILED_RESPONSE_GET_ARTICLES_SOLICITOR_HOME_PAGE,
		payload
	}
}

//action that requests patch article
export function requestPatchArticle(articleId) {
	return {
		type: REQUEST_PATCH_ARTICLE,
		payload: articleId
	}
}

//action that receives patch article
export function receivePatchArticle(response) {
	return {
		type: RECEIVE_PATCH_ARTICLE,
		payload: response
	}
}

//action that  receives failed response from patching article
export function receiveFailedResponsePatchArticle(response) {
	return {
		type: RECEIVE_FAILED_RESPONSE_PATCH_ARTICLE,
		payload: response
	}
}


//action that requests delete article
export function requestDeleteArticle(articleId) {
	return {
		type: REQUEST_DELETE_ARTICLE,
		payload: articleId
	}
}

//action that receives delete article
export function receiveDeleteArticle(response, id) {
	return {
		type: RECEIVE_DELETE_ARTICLE,
		payload: {
			response,
			id
		}
	}
}

//action that  receives failed response from deleting article
export function receiveFailedResponseDeleteArticle(response) {
	return {
		type: RECEIVE_FAILED_RESPONSE_DELETE_ARTICLE,
		payload: response
	}
}

//action that requests get specific article
export function requestGetSelectedArticle(articleId) {
	return {
		type: REQUEST_GET_SELECTED_ARTICLE,
		payload: articleId
	}
}

//action that receives get specific article
export function receiveSpecificArticle(article) {
	return {
		type: RECEIVE_SPECIFIC_ARTICLE,
		payload: article
	}
}

//action that  receives failed response from getting specific article
export function receiveFailedResponseGetSpecificArticle(response) {
	return {
		type: RECEIVE_FAILED_RESPONSE_GET_SPECIFIC_ARTICLE,
		payload: response
	}
}



export function requestArticlesMessage(){
	return {
		type: REQUEST_ARTICLES_MESSAGE
	}
}

export function receiveArticlesMessage(payload){
	return {
		type: RECEIVE_ARTICLES_MESSAGE,
		payload
	}
}

export function receiveBadRequestArticlesMessage(payload){
	return {
		type: RECEIVE_BAD_REQUEST_ARTICLES_MESSAGE,
		payload
	}
}

//action that requests get article news
export function requestGetArticleAttachment(payload) {
	return {
		type: REQUEST_ARTICLE_ATTACHMENT,
		payload
	}
}

//action that receives all articles
export function receiveGetArticleAttachment(payload) {
	return {
		type: RECEIVE_ARTICLE_ATTACHMENT,
		payload
	}
}

//action that  receives failed response from getting all articles
export function receivefailedGetArticleAttachment(payload) {
	return {
		type: RECEIVE_FAILURE_ARTICLE_ATTACHMENT,
		payload
	}
}
